import axios from 'axios';
import { getApiBaseUrl } from '../config/config';

export default axios.create({
  baseURL: getApiBaseUrl(),
});
